/**
 * 创建人：段锐
 * 时间：2019-7-01
 * 描述：为视频播放组件提供服务:创建和销毁组件
 * 更新记录: 
 */
import { Injectable, Injector, ApplicationRef, ComponentFactoryResolver } from '@angular/core';
import { SwVideoComponent } from './sw-video.component';
import { SwDestructionService } from 'src/app/librarys/serves/sw-destruction.service';

/**
 * 创建视频服务
 */
@Injectable({
  providedIn: 'root'
})
export class SwVideoService {

  /**
   * @ignore
   * @param injector 
   * @param applicationRef 
   * @param componentFactoryResolver 
   * @param SwDestructionService 
   */
  constructor(private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private SwDestructionService: SwDestructionService ///注入销毁组件的服务
  ) { }

  /**
   * 关闭视频
   */
  closeVideo() {
    const rootpop = document.createElement("sw-video");
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwVideoComponent);
    const componentRef = factory.create(this.injector, [], rootpop);
    this.applicationRef.attachView(componentRef.hostView);
    //调用组件内的关闭方法
    componentRef.instance.closeVideo();

  }
  
  /**
   * 打开视频
   * @param title 显示名称 
   * @param src  视频地址
   */
  openVideo(title: string, src: string) {
    //销毁之前的组件
    this.SwDestructionService.destruction("sw-video");

    const rootpop = document.createElement("sw-video");
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwVideoComponent);
    const componentRef = factory.create(this.injector, [], rootpop);
    this.applicationRef.attachView(componentRef.hostView);
    componentRef.instance.voted.subscribe(() => {
      //销毁组件
      document.body.removeChild(rootpop);
      this.applicationRef.detachView(componentRef.hostView);
      componentRef.destroy();
    });
    //传递参数
    componentRef.instance.title = title;
    componentRef.instance.src = src;
    //调用组件内的打开方法
    componentRef.instance.openVideo();
    document.body.appendChild(rootpop);
  }
}
